import { motion, useMotionValue } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import "./style.css";
import NewProductHome from "../NewProductHome";
import UseFetch from "../../hook/useFetch";
import { useInView } from "framer-motion";

export default function NewHome() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const { data } = UseFetch(
    "https://ebuy-backend-two.vercel.app/api/article"
  );

  const produits = Array.isArray(data)
    ? data.slice(-20).reverse()
    : [];

  const extendedProducts = [...produits, ...produits];

  const x = useMotionValue(0);
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [cardWidth, setCardWidth] = useState(260);

  // responsive card width
 useEffect(() => {
  const update = () => {
    if (window.innerWidth < 600) setCardWidth(220);
    else if (window.innerWidth < 900) setCardWidth(240);
    else setCardWidth(260);
  };
  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);

useEffect(() => {
  if (carouselRef.current) {
    const width = carouselRef.current.scrollWidth / 2;
    x.set(-width / 2);
  }
}, [x]);

  // auto-scroll
useEffect(() => {
  let raf;
  const speed = 30; // px/sec

  const animate = () => {
    if (!isDragging && carouselRef.current) {
      const width = carouselRef.current.scrollWidth / 2;
      const currentX = x.get();

      if (currentX <= -width) {
        x.set(0);
      } else {
        x.set(currentX - speed * 0.016);
      }
    }

    raf = requestAnimationFrame(animate);
  };

  raf = requestAnimationFrame(animate);
  return () => cancelAnimationFrame(raf);
}, [isDragging, x]);




  return (
    <section
      ref={ref}
      className="slideNew"
      style={{
        transform: isInView ? "none" : "translateY(200px)",
        opacity: isInView ? 1 : 0,
        transition:
          "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
      }}
    >
      <h2 className="bigTitleSlide">Nouveautés</h2>

      <div className="carousel-wrapper">
        <motion.div
          ref={carouselRef}
          className="carousel-track"
          style={{ x }}
          drag="x"
          dragMomentum={false}
          dragElastic={0.08}
          onDragStart={() => setIsDragging(true)}
          onDragEnd={() => setIsDragging(false)}
          onHoverStart={() => setIsDragging(true)}
          onHoverEnd={() => setIsDragging(false)}
        >
          {extendedProducts.map((produit, index) => (
           <motion.div
  key={index}
  style={{ minWidth: cardWidth }}
  className="product-slide"
  whileHover={{ scale: 1.04 }}
  transition={{ type: "spring", stiffness: 200 }}
>
  <NewProductHome
    categorie={produit.categorie}
    subcategorie={produit.subcategorie}
    subSubcategorie={produit.subSubcategorie}
    article={produit.article}
    prix={produit.prix}
    colors={produit.colors}
    brand={produit.brand}
    famille={produit.famille}
    reference={produit.ref}
    stock={produit.stock}
      nouveau={produit.nouveau}
      livraisonGratuit={produit.livraisonGratuit}
  />
</motion.div>

          ))}
        </motion.div>
      </div>
    </section>
  );
}
